var Backbone = require('backbone')
var SurveyItemOptionModel = require('./Option')
var OptionsCollection = Backbone.Collection.extend({
  model: SurveyItemOptionModel
})

module.exports = Backbone.Model.extend({
  defaults: {
    type: null,
    title: null,
    options: OptionsCollection
  },

  initialize: function (data) {
    if (data.type === 'multiselect') {
      this.set('options', new OptionsCollection(data.options || []))
    }
  }
})
